import { PACSCommunicationCtor } from 'app/interfaces/PACSCommunication';
import React from 'react';

const PACSCommunicationInjector = React.createContext<PACSCommunicationCtor>(undefined);

export default PACSCommunicationInjector;
